import "moment/locale/ko";
import React from "react";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";

import "assets/fonts/notosans/style.css";
import "assets/base.css";

import PageIndex from "./pages";
import { store } from "store";
import theme from "theme";
import ThemeProvider from "./ThemeProvider";

const queryClient = new QueryClient();

Modal.setAppElement("#root");

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <Router>
              <PageIndex />
            </Router>
          </ThemeProvider>
        </QueryClientProvider>
      </Provider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
